/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Russian
export default {
  'editorExtensionLinkCreate.confluencePage.newDraftTitle': 'Страница без названия',
  'editorExtensionLinkCreate.confluencePage.quickInsert.description': 'Создать страницу и вставить ее как ссылку',
  'editorExtensionLinkCreate.confluencePage.quickInsert.title': 'Создать страницу Confluence',
  'editorExtensionLinkCreate.confluencePage.successFlag.action.open': 'Открыть в Confluence',
  'editorExtensionLinkCreate.confluencePage.successFlag.description': 'Страница создана',
  'editorExtensionLinkCreate.confluencePage.successFlag.title': 'Страница создана',
  'editorExtensionLinkCreate.confluencePage.title': 'Создание страницы',
  'editorExtensionLinkCreate.genericError.description': 'Обновите страницу и повторите попытку.',
  'editorExtensionLinkCreate.genericError.title': 'Произошла ошибка',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.description': 'Создать встроенную задачу и вставить ее как ссылку',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.description-issue-terminology-refresh-m4':
    'Создать встроенную задачу и вставить ее как ссылку',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.title': 'Создать задачу Jira',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.title-issue-terminology-refresh-m4': 'Создать задачу Jira',
  'editorExtensionLinkCreate.jiraIssue.successFlag.action.open': 'Открыть в Jira',
  'editorExtensionLinkCreate.jiraIssue.successFlag.description': 'Задача создана',
  'editorExtensionLinkCreate.jiraIssue.successFlag.description-issue-terminology-refresh-m4': 'Задача создана',
  'editorExtensionLinkCreate.jiraIssue.successFlag.title': 'Задача создана',
  'editorExtensionLinkCreate.jiraIssue.successFlag.title-issue-terminology-refresh-m4': 'Задача создана',
  'editorExtensionLinkCreate.jiraIssue.title': 'Создание задачи',
  'editorExtensionLinkCreate.jiraIssue.title-issue-terminology-refresh-m4': 'Создание задачи',
  'editorExtensionLinkCreate.keyword.create': 'создать',
  'editorExtensionLinkCreate.keyword.issue': 'задача',
  'editorExtensionLinkCreate.keyword.new': 'новый',
  'editorExtensionLinkCreate.keyword.page': 'страница',
  'editorExtensionLinkCreate.keyword.publish': 'опубликовать',
  'editorExtensionLinkCreate.keyword.raise': 'создать',
  'editorExtensionLinkCreate.keyword.space': 'раздел',
  'editorExtensionLinkCreate.keyword.ticket': 'заявка',
};
